export default "__VITE_ASSET__C8HIv4qg__"